import {AfterViewInit, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {MessageContact} from "../../model/MessageContact";
import {Subject, Subscription} from "rxjs";
import {ChatMessageService} from "../../message.service";
import {MessageGroupComponent} from "../message-group/message-group.component";
import {RoomChat} from "../../model/RoomChat";
import {GroupCallListComponent} from "../group-call-list/group-call-list.component";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";

declare let $: any;
declare let iNet: any;

@Component({
  selector: 'message-contact-list',
  templateUrl: './contact-list.component.html',
  styleUrls: ['./contact-list.component.scss']
})
export class ContactListComponent implements OnInit, OnDestroy, AfterViewInit {
  @Output() contactSelected = new EventEmitter<MessageContact>();
  @Output() roomSelected = new EventEmitter<any>();
  @Output() callTo = new EventEmitter<string>();
  @ViewChild('contactRef') contactRef!: ElementRef;
  @ViewChild(MessageGroupComponent) messageGroupComponent!: MessageGroupComponent;
  @ViewChild(GroupCallListComponent) groupCallList!: GroupCallListComponent;
  contacts: MessageContact[] = [];
  statusText: string = '';
  userInteract: boolean = false;
  lastPage: boolean = false;
  username = iNet.username;
  fullname = iNet.displayName;
  flagContactOrRoom = false;
  checkIndex: any;
  groups: RoomChat[] = [];

  private _contacts: MessageContact[] = [];
  private _statusObserver?: Subscription | null;
  private _pageNumber: number = 0;
  private _pageSize: number = 20;
  private _loading: boolean = false;
  private _timer: any;
  private _contactEl: any;
  private _keyword: any;
  private searchContactSub$ = new Subject<string>();
  private searchGroupSub$ = new Subject<string>();

  constructor(private messageService: ChatMessageService) {
  }

  ngOnInit(): void {
    this.searchContactSub$.pipe(
      debounceTime(250),
      distinctUntilChanged()
    ).subscribe((keyword: string) => {
      keyword = keyword.toLowerCase().trim();
      if (keyword === this._keyword) {
        return;
      }
      this._keyword = keyword;
      this.messageService.searchContacts(keyword, (contacts: any) => {
        this._pageNumber = 0;
        this._loading = false;
        this._contacts = contacts;
        this.contacts.length = 0;
        this.loadContacts();
      });
    });

    this.searchGroupSub$.pipe(
      debounceTime(250),
      distinctUntilChanged()
    ).subscribe((value: string) => {
      value = value.toLowerCase().trim();
      const arrayTemp: any[] = [];
      this.messageService.getGroupMessageList().subscribe(data => {
        data.items.forEach((itemList: any) => {
          if (this.removeAccents(itemList.subject).toLowerCase().search(this.removeAccents(value)) >= 0) {
            arrayTemp.push(itemList);
          }
        });
        this.groups = arrayTemp;
      });
      this.loadGroup(this.groups);
    });
  }

  ngAfterViewInit() {
    this._contactEl = $(this.contactRef.nativeElement);
    this._detectUserInteract();
    this.searchContacts();
    this.searchGroups();
    this._statusObserver = this.messageService.socketService.onStateChange.subscribe(() => {
      if (this.messageService.socketService.closed) {
        this.statusText = 'Kết nối không thành công';
      } else if (this.messageService.socketService.connecting) {
        this.statusText = 'Đang kết nối';
      } else if (this.messageService.socketService.connected) {
        this.statusText = '';
      }
    });

    // Scroll bottom load more
    this._contactEl.on('scroll', (e: any) => {
      if (this._loading || this.lastPage) {
        return;
      }
      if (e.target.scrollTop + e.target.clientHeight > e.target.scrollHeight - 100) {
        this.loadContacts();
      }
    });
  }

  ngOnDestroy() {
    if (this._statusObserver) {
      this._statusObserver.unsubscribe();
      this._statusObserver = null;
    }

    if(this.searchContactSub$) {
      this.searchContactSub$.unsubscribe();
    }

    if(this.searchGroupSub$) {
      this.searchGroupSub$.unsubscribe();
    }
  }

  selectContact(contact: MessageContact) {
    // console.log('contact', contact)
    this.contactSelected.emit(contact);
    this.checkIndex = this.contacts.indexOf(contact);
  }

  searchContacts(value: string = '') {
    this.searchContactSub$.next(value);
  }

  private removeAccents(str: any) {
    //String function in inet-core
    return (str as any).removeAccents();
  }

  searchGroups(value: string = '') {
   this.searchGroupSub$.next(value);
  }

  loadContacts() {
    if (!this.userInteract || this._loading || !this._contacts) {
      return;
    }
    const begin = this._pageNumber * this._pageSize;
    this.lastPage = this._contacts && this._contacts.length < begin;
    if (this.lastPage) {
      return;
    }
    this._loading = true;

    this.contacts = this.contacts.concat(this._contacts.slice(begin, begin + this._pageSize));
    this.contacts = this.contacts.filter((contact)=> {
      return contact.usercode!=iNet.username;
    });

    // this.contacts = this._contacts;

    this.contacts.forEach((ele: any) => {
      let __mes = this.messageService.revertMessage(ele.message) || '';
      let __mesDisplay = this.messageService.revertMessageDisplay(ele.message) || '';
      let typeMessages = __mes.split(":");
      if (typeMessages.length > 0) {
        if (typeMessages[0] === 'uri_message' && (typeMessages[1] === 'video_conference...' || typeMessages[1] === 'video_conference')) {
          ele.message = '<i class="fa fa-phone pr-1" aria-hidden="true"></i> Cuộc gọi thoại';
          return ele;
        } else {
          if (typeMessages[0] === 'uri_message' && typeMessages[1] === 'link_preview...') {
            ele.message = __mesDisplay;
            return ele;
          } else {
            return ele;
          }
        }
      }
    });
    setTimeout(() => {
      this._loading = false;
      this._pageNumber++;
    }, 300);
    // console.log(this._contacts)
    this.selectContact(this.contacts[0]);
  }

  loadContactSelect(data: any) {
    if (data.length > 0) {
      this.selectContact(data[0]);
      this.checkIndex = 0;
      this.checkActive(0);
    }
  }

  loadGroup(data: any) {
    if (data.length > 0) {
      this.selectRoom(this.groups[0]);
      this.groupCallList.checkIndex = 0;
      this.groupCallList.checkActive(0)
    }
  }

  decodeBase64(str: string) {
    return decodeURIComponent(escape(window.atob(str)));
  }

  private _detectUserInteract() {
    this._timer = setInterval(() => {
      if (this._contactEl.is(':visible')) {
        this.userInteract = true;
        this.loadContacts();
        clearInterval(this._timer);
        this._timer = null;
      }
    }, 100);
  }

  selectRoomAndReload(roomName: string) {
    this.selectRoom(roomName);
  }

  selectRoom(roomName: any) {
    // console.log('test', roomName)
    // this.roomSelected.emit(roomName);
    this.roomSelected.emit(roomName);
  }

  callToContact(usercode: any) {
    this.callTo.emit(usercode);
  }

  createGroup() {
    this.messageGroupComponent.showModalAndResetListMember();
  }

  searchContactOrGroup(flag: any) {
    this.flagContactOrRoom = flag;
  }

  checkActive(index: any) {
    return index == this.checkIndex
  }
}
